export enum SalesGateway {
  Stripe = "stripe",
  HeyLight = "heylight",
  Bonifico = "bonifico",
}

export const SALES_GATEWAYS = [
  SalesGateway.Stripe,
  SalesGateway.HeyLight,
  SalesGateway.Bonifico,
];

export enum SaleKind {
  Sale = "sale",
  Settlement = "settlement",
}

export enum SaleOutcome {
  Completed = "completed",
  Awaiting = "awaiting",
  Abandoned = "abandoned",
  Declined = "declined",
  ManuallyHandled = "manually_handled",
}

export type SaleCustomer = {
  email: string;
  firstName: string;
  lastName: string;
};

export type SoldItem = {
  id: string;
  type: "product" | "bundle";
  name: string | null;
};

export type SalePayment = {
  paidAtUtc: string;
  amountInCents: number;
};

export type SaleRefund = {
  refundedAtUtc: string;
  amountInCents: number;
};

export type UpcomingInstallment = {
  dueAtUtc: string;
  amountInCents: number;
};

export type SaleRecord = {
  orderId: string;
  gateway: SalesGateway;
  customer: SaleCustomer;
  kind: SaleKind;
  outcome: SaleOutcome;
  status: string;
  declineReason: string | null;
  orderedAtUtc: string;
  paymentMethod: string | null;
  numberOfInstallments: number | null;
  item: SoldItem | null;
  listPriceInCents: number;
  couponCode: string | null;
  couponDiscountInCents: number;
  amountDueInCents: number;
  payments: SalePayment[];
  refunds: SaleRefund[];
  upcomingInstallments: UpcomingInstallment[];
  overdueInCents: number;
};

export function isConcludedSale(record: SaleRecord): boolean {
  return (
    record.kind === SaleKind.Sale && record.outcome === SaleOutcome.Completed
  );
}

export function sumOf<Item>(
  items: Item[],
  amountOf: (item: Item) => number,
): number {
  return items.reduce((total, item) => total + amountOf(item), 0);
}

export function paidAmountOf(record: SaleRecord): number {
  return sumOf(record.payments, (payment) => payment.amountInCents);
}

export function refundedAmountOf(record: SaleRecord): number {
  return sumOf(record.refunds, (refund) => refund.amountInCents);
}
